import Vue from 'vue'
import VueRouter from 'vue-router'
// import Layout from '@/layout'
import Home from '@/views/home'
import MobileHome from '@/views/mobile/home'
import { isMobile } from '@/utils/index'
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/mobile/home',
        name: 'MobileHome',
        component: MobileHome,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, form, next) => {
    if (isMobile() && to.path != '/mobile/home') {
        next({ path: '/mobile/home' })
        return
    } else if (!isMobile() && to.path != '/') {
        next({ path: '/' })
        return
    }
    next()
})

export default router
